import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import closeIcon from "../../../assets/image/close.png";
import { useSubmitAssignmentMutation } from "../../../features/assignmentMark/assignmentMarkApi";
import { useGetAssignmentQuery } from "../../../features/assignments/assignmentsApi";
import Error from "../../ui/Error";

export default function AssignmentSubmitModal({ open, control, assignmentId }) {
  const { user } = useSelector((state) => state.auth);
  const { id: userId, name } = user || {};

  const { data: assignment } = useGetAssignmentQuery(assignmentId) || {};

  const { title, totalMark, id } = assignment || "";

  const [repoLink, setRepoLink] = useState("");

  const [submitAssignment, { isLoading, isSuccess, isError, error }] =
    useSubmitAssignmentMutation();

  useEffect(() => {
    if (isSuccess) {
      control();
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    submitAssignment({
      data: {
        student_id: userId,
        student_name: name,
        assignment_id: id,
        title,
        createdAt: new Date(),
        totalMark,
        mark: 0,
        repo_link: repoLink,
        status: "pending",
      },
    });
  };

  return (
    open && (
      <>
        <div
          onClick={control}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 text-white bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <button
            className="absolute close-icon bg-transparent text-white font-bold text-xl focus:outline-none"
            onClick={control}
          >
            <img src={closeIcon} alt="Close Icon" />
          </button>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            Assignment Submission
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="repo_link" className="sr-only">
                  Repository Link
                </label>
                <input
                  id="repo_link"
                  name="repo_link"
                  type="text"
                  required
                  className="my-4 appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-black rounded-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Write repository link ..."
                  value={repoLink}
                  onChange={(e) => setRepoLink(e.target.value)}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                disabled={isLoading}
              >
                Submit Assignment
              </button>
            </div>

            {isError && <Error message={error?.data} />}
          </form>
        </div>
      </>
    )
  );
}
